export default __webpack_public_path__ + "static/media/tomatoPlant_x1024.52d0f4aa.png";